'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _mapObj = require('map-obj');

var _mapObj2 = _interopRequireDefault(_mapObj);

var isObject = function isObject(v) {
  return typeof v === 'object';
};

var camelCase = function camelCase(str) {
  return str.replace(/[_.-](\w|$)/g, function (_, x) {
    return x.toUpperCase();
  });
};

function objectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}

function camelCaseRecursive(obj) {
  var transform = obj == null ? obj : (0, _mapObj2['default'])(obj, function (key, val) {
    var newArray = [];

    if (Array.isArray(val)) {
      val.forEach(function (value) {
        if (isObject(value) && !Array.isArray(value)) {
          newArray.push(camelCaseRecursive(value));
        } else {
          newArray.push(value);
        }
      });
      return [camelCase(key), newArray];
    } else if (!val) {
      return [camelCase(key), val];
    } else if (val instanceof Date) {
      return [camelCase(key), val];
    } else if (isObject(val)) {
      return [camelCase(key), camelCaseRecursive(val)];
    }

    return [camelCase(key), val];
  });
  return Array.isArray(obj) ? objectValues(transform) : transform;
}

exports['default'] = camelCaseRecursive;
module.exports = exports['default'];